import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  standalone: true,
  template: `
    <div style="padding:80px 0 60px 0;">
      <h2>404 - Page Not Found</h2>
      <p style="text-align: center; padding-top:40px;">
        No page found for this request.<br />
      </p>
    </div>    
  `
})
export class NotFoundComponent {}